import { render, staticRenderFns } from "./Template52.vue?vue&type=template&id=a30eb7b4&scoped=true&"
import script from "./Template52.vue?vue&type=script&lang=js&"
export * from "./Template52.vue?vue&type=script&lang=js&"
import style0 from "./Template52.vue?vue&type=style&index=0&id=a30eb7b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30eb7b4",
  null
  
)

export default component.exports